import { c as _c } from "react/compiler-runtime";
import { Grid } from "@mui-wrapper";
import { INTEGRATION_INFO } from "@src/constants/integrations-constants";
import { Dialog, FontWeights, Text } from "@flat-ui";

/** Shows dialog for integration in progress */
export function IntegrationsInProgressDialog(t0) {
  const $ = _c(14);
  const {
    integrationId,
    dialogCancelCallback
  } = t0;
  const IntegrationIcon = INTEGRATION_INFO[integrationId].icon;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      alignItems: "center",
      flexDirection: "column"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      marginBottom: "30px",
      width: "95px",
      height: "95px"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== IntegrationIcon) {
    t3 = <IntegrationIcon sx={t2} />;
    $[2] = IntegrationIcon;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      fontWeight: FontWeights.Regular,
      marginBottom: "30px"
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = INTEGRATION_INFO[integrationId];
  let t6;
  if ($[5] !== t5.displayName) {
    t6 = <Text variant="heading20" sx={t4}>{t5.displayName} authorization</Text>;
    $[5] = t5.displayName;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Text variant="bodyM" sx={{
      marginTop: "0px",
      marginBottom: "30px"
    }}>Please complete the authorization in the window that just opened.</Text>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t3 || $[9] !== t6) {
    t8 = <Grid container={true} sx={t1}>{t3}{t6}{t7}</Grid>;
    $[8] = t3;
    $[9] = t6;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== dialogCancelCallback || $[12] !== t8) {
    t9 = <Dialog open={true} onConfirm={dialogCancelCallback} confirmText="Cancel authorization" title="">{t8}</Dialog>;
    $[11] = dialogCancelCallback;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  return t9;
}